import { createStore, createEvent, createEffect, combine } from 'effector';
import request from '@helpers/request';
import api from '@constants/endpoints';
import IUser from '@interfaces/IUser';
import { PaginationProps } from 'antd/lib/pagination';
import createPaginationStore from './pagination';
import createFiltersStore from './filters';
import IComment from '@interfaces/IComment';
import { get } from 'lodash';

export const reset = createEvent('UserComments store reset');
const defaultFilters = {
  sort: 'createdDateTime,desc',
};
export const getComments = createEffect({
  name: 'getComments',
  async handler(params: {
    userId?: IUser['id'];
    pagination?: PaginationProps;
    filters?: Record<string, string>;
  }) {
    const paginationParams: PaginationProps = {
      ...pagination.getState(),
      ...params?.pagination,
    };
    const { pageSize, current } = paginationParams;
    const response = await request(api.comments.getUsersComments, {
      urlParams: {
        accountId: params.userId,
      },
      data: {
        pagination: {
          page: (current || 1) - 1,
          type: 'PAGE',
          pageSize,
        },
      },
    });
    return response;
  },
});

const { pagination } = createPaginationStore({
  getList: getComments,
  listName: 'userComments',
  resetEvent: reset,
  bodyPath: ['data', 'body', 'comments'],
});

const { filters, setFilters } = createFiltersStore({
  listName: 'userComments',
  deaultValues: defaultFilters,
  resetEvent: reset,
});

export { filters, setFilters };

const commentsList = createStore<IComment[]>([])
  .on(getComments.done, (state, { result }) => {
    return get(result, ['data', 'body', 'comments', 'page']);
  })
  .reset(reset);

const userComments = combine({ commentsList, pagination });

export default userComments;
